export default "__VITE_ASSET__DlYQqCV7__"